export enum MapObject {
  LINES = "Lines",
  POLYGONS = "Polygons",
  FILES = "Files"
}
